import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE
} from '@/constants/locale'
import { loadElementPlusLocale } from '@/locales'
import { syncDocumentTitleFromRoute } from '@/utils/syncDocumentTitle'

/** 全局 Element Plus locale（App.vue el-config-provider 使用） */
const elementPlusLocale = ref(null)

/** 初始化 Element Plus 语言包 */
export async function initElementPlusLocale (locale = DEFAULT_LOCALE) {
  elementPlusLocale.value = await loadElementPlusLocale(locale)
}

/**
 * 应用语言切换：vue-i18n + Element Plus + localStorage + document.lang
 */
export function useAppLocale () {
  const { locale, t } = useI18n()

  const currentLocale = computed(() => locale.value)
  const localeOptions = SUPPORTED_LOCALES

  const setLocale = async (next) => {
    if (!next || next === locale.value) return
    if (!SUPPORTED_LOCALES.some((item) => item.value === next)) return

    locale.value = next
    localStorage.setItem(LOCALE_STORAGE_KEY, next)
    document.documentElement.lang = next === 'en' ? 'en' : 'zh-CN'
    elementPlusLocale.value = await loadElementPlusLocale(next)
    syncDocumentTitleFromRoute()
  }

  watch(
    locale,
    (val) => {
      document.documentElement.lang = val === 'en' ? 'en' : 'zh-CN'
    },
    { immediate: true }
  )

  return {
    t,
    currentLocale,
    localeOptions,
    elementPlusLocale,
    setLocale
  }
}

export { elementPlusLocale }
